// src/utils/planAccess.js

export const isFreeUser = () => {
    return localStorage.getItem("plan") === "free";
  };